import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function useUnreadCounts(userId?: string) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!userId) return;

    const load = async () => {
      const { data } = await supabase.rpc('get_total_unread_count', { p_user_id: userId });
      setCount(typeof data === 'number' ? data : 0);
    };

    load();
  }, [userId]);

  return count;
}
